import {
  ISalePageDetailResponseProduct,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import { Divider, Element } from '@vuddy/components';
import { ChangeEvent, Fragment } from 'react';
import { PurchaseRadioItemDesktop } from './PurchaseRadioItemDesktop';

interface IDigitalItemListDesktopProps {
  itemList: (ISalePageDetailResponseProduct &
    ISalePageProductAdditionalInformResponse)[];
  selectedId?: number;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onCodeInputClick?: (itemId: number) => void;
  // key: productId, value: 검증된 promotionCode
  verifiedProductCodes?: Map<number, string>;
}

export const DigitalItemListDesktop = ({
  itemList,
  selectedId,
  onChange,
  onCodeInputClick,
  verifiedProductCodes,
}: IDigitalItemListDesktopProps) => {
  const length = itemList?.length || 0;

  return (
    <Element>
      {itemList.map((item, idx) => (
        <Fragment key={item.id}>
          <PurchaseRadioItemDesktop
            item={item}
            selectedId={selectedId}
            onChange={onChange}
            hasVerificationCode={item.requiresPromotionCode}
            verificationCodeName={verifiedProductCodes?.get(item.id)}
            onCodeInputClick={() => onCodeInputClick?.(item.id)}
          />
          {/* 맨 마지막 아이템은 디바이더 안 넣어줌 */}
          {idx !== length - 1 && <Divider />}
        </Fragment>
      ))}
    </Element>
  );
};
